module.exports = __webpack_public_path__ + "static/media/Kiwi – 1.d3b56d74.jpg";